/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HealthResponse,
} from '../models/index';
import {
    HealthResponseFromJSON,
    HealthResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class HealthApi extends runtime.BaseAPI {

    /**
     * Health check endpoint that returns application information.  This endpoint provides basic information about the application including version, environment, and development status.  Args:     settings: Application settings dependency  Returns:     Dictionary containing application health information
     * Health
     */
    async healthApiV1HealthGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/health/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthResponseFromJSON(jsonValue));
    }

    /**
     * Health check endpoint that returns application information.  This endpoint provides basic information about the application including version, environment, and development status.  Args:     settings: Application settings dependency  Returns:     Dictionary containing application health information
     * Health
     */
    async healthApiV1HealthGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthResponse> {
        const response = await this.healthApiV1HealthGetRaw(initOverrides);
        return await response.value();
    }

}
